export const getDirectParentFromBreadcrumbs = (breadcrumbs) => breadcrumbs && breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 2] : undefined;
export const getBreadcrumbsString = (breadcrumbs, depth = 1) => {
    if (!breadcrumbs || breadcrumbs.length <= depth)
        return undefined;
    const path = breadcrumbs.slice(0, -depth);
    if (path.length <= 2)
        return path.join(' > ');
    return `${path[0]} > ... > ${path[path.length - 1]}`;
};
